/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_people_outline_big_circle from "../../assets/images/pictures/icon/ic_peoples_outline_big_circle-64px.svg";
import ic_beenhere_circle from "../../assets/images/pictures/icon/ic_beenhere_circle-40px.svg";
import ic_exit_app_circle from "../../assets/images/pictures/icon/ic_exit_to_app_circle-40px.svg";
import ic_category_circle from "../../assets/images/pictures/icon/ic_category_circle-40px.svg";
import ic_devices_circle from "../../assets/images/pictures/icon/ic_devices_circle.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import elec from "../../assets/images/logos/case/electronic.png";
import ignitis from "../../assets/images/logos/case/ignitis.png";
import fjr from "../../assets/images/logos/case/fjr.png";
import cover from "../../assets/images/logos/case/cover-public.png";
import NavbarBottom from "../../components/global/NavbarBottom";

const CaseStudiesPublicContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="industries mt-50">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_people_outline_big_circle}
                alt=""
                data-no-retina=""
              />
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-1.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-sm-10 col-sm-offset-1 mb-60">
              <ul className="list-inline text-center">
                <li>
                  <img
                    className="img-bw client-cases"
                    src={elec}
                    alt="Elektroniniai Valdžios Vartai"
                  />
                </li>
                <li>
                  <img
                    className="img-bw client-cases"
                    src={ignitis}
                    alt="Ignitis group"
                  />
                </li>
                <li>
                  <img
                    className="img-bw client-cases"
                    src={fjr}
                    alt="Fjármála- og efnahagsráðuneytið"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-color p-0 mt-50">
        <div className="container">
          <div className="row stages">
            <div className="col-xs-12 text-center">
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-2.big-heading"
                )}
              </h2>
            </div>
            <div className="col-xs-12 text-center mb-10">
              <p>
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-2.big-description"
                )}
              </p>
            </div>
          </div>
          <div className="row b-30">
            <div className="col-sm-6 stages-legal__box pl-md-0">
              <img src={ic_beenhere_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-heading-1"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-description-1"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-6 stages-legal__box pr-md-0">
              <img src={ic_exit_app_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-heading-2"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-description-2"
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="row mb-80">
            <div className="col-sm-6 stages-legal__box pl-md-0">
              <img src={ic_category_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-heading-3"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-description-3"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-6 stages-legal__box pr-md-0">
              <img src={ic_devices_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-heading-4"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-public-page.case-studies-public-page-content.content-2.small-description-4"
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="industries">
        <div className="container">
          <div className="row about-pro">
            <div className="col-sm-5 pl-md-0">
              <img
                className="img-responsive"
                src={cover}
                alt="Thumbnail pages of E-signing and e-identification in public sector: A White Paper"
              />
            </div>
            <div className="col-sm-7">
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-3.description-2"
                )}
              </p>
              <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-public-page.case-studies-public-page-content.content-3.button-access"
                )}
              </a>
            </div>
          </div>
        </div>
        <CaseStudiesChildFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesPublicContent;
